import api from '@shared/services/api';
import { UserAnalyticsResponse } from '../hooks/useAnalyticsData';

export class AnalyticsService {
  private static readonly BASE_URL = '/analytics';

  /**
   * Get performance data for all sections for charts
   */
  static async getAllSectionsChartData(): Promise<UserAnalyticsResponse> {
    try {
      const response = await api.get<UserAnalyticsResponse>(`${this.BASE_URL}/user`);
      return response.data;
    } catch (error) {
      console.error('Error fetching all sections chart data:', error);
      throw error;
    }
  }
}
